import { DvaReducer } from '@/models/shared';
import { Subscription } from 'dva';
import type { InformalNodeManagerPageModelState, ChangeAction, InformalNodeManagerPageModelType } from './types';
import { initialState } from './initialState';
import { pageEffects } from './pageEffects';
import { exhibitEffects } from './exhibitEffects';
import { themeEffects } from './themeEffects';
import { ruleEffects } from './ruleEffects';
import { drawerEffects } from './drawerEffects';
import { replaceModalEffects } from './replaceModalEffects';

export type { InformalNodeManagerPageModelState };
export * from './types';
export { ruleMatchAndResult } from './helpers';

const Model: InformalNodeManagerPageModelType = {
  namespace: 'informalNodeManagerPage',
  state: initialState,
  effects: {
    ...pageEffects,
    ...exhibitEffects,
    ...themeEffects,
    ...ruleEffects,
    ...drawerEffects,
    ...replaceModalEffects,
  },
  reducers: {
    change(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
  subscriptions: {
    setup({}) {

    },
  },
};

export default Model;
